'use client';

import clsx from 'clsx';
import { useEffect, useState } from 'react';

import { isMswEnabled, setMswEnabled } from './config';

/**
 * 개발용 MSW on/off 토글 버튼 (우측 하단 고정).
 * 운영 빌드(NODE_ENV !== 'development')에선 렌더 안 함.
 * 클릭 시 localStorage 저장 후 페이지 reload.
 */
export function MswToggle() {
  const [mounted, setMounted] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true);
    setEnabled(isMswEnabled());
  }, []);

  if (!mounted) return null;
  if (process.env.NODE_ENV !== 'development') return null;

  return (
    <button
      type="button"
      onClick={() => setMswEnabled(!enabled)}
      aria-pressed={enabled}
      className={clsx(
        'fixed right-12 bottom-12 z-9999',
        'shadow-200 rounded-full px-12 py-6',
        'text-[11px] font-bold tracking-wide',
        enabled ? 'bg-primary-600 text-gray-100' : 'bg-gray-1000 text-gray-100',
      )}
      title="MSW 토글 (클릭 시 페이지가 새로고침됩니다)"
    >
      MSW {enabled ? 'ON' : 'OFF'}
    </button>
  );
}
